module.exports = __webpack_public_path__ + "img/guaduan.39f6ba6a.png";